export default __webpack_public_path__ + "static/media/low-credits-alert.cf8e2457.svg";